

// 2020-10
export function formatQueryDate(date) {
  if (!date) {
    return undefined;
  }
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  return year + "-" + (month < 10 ? "0" + month : month);
}

export function formatQueryYear(date) {
  if (!date) {
    return date;
  }
  let year = date.getFullYear();
  return year.toString();
}

const variables = {
  Code_OK: 10000000,
  Code_Err: 20000000,
  Err_Msg: '系统异常',
  Ok_Msg: '操作成功',
  Upload_OK_Msg: '上传成功',
  Add_OK_Msg: '创建成功',
  Delete_Tip: '此操作将永久删除该文件, 是否继续?',
  No_Select_Tip: '请先选择操作的目标',
  One_Select_Tip: '每次操作只能选择一项',
  Approve_One_Tip: '每次审批请选择一项',
  Approve_Opinion: '请填写审批意见',
}

export default variables